// HOC shared by both register and account flows
import { withNewPickupPersonForm } from 'components/account/PickupPeople/New'

// presentational component
import UI from './UI'

// in reg flow, report progress to GTM and redirect to pick-up people list
export default withNewPickupPersonForm({
  onSuccess: data =>
    window.dataLayer &&
    window.dataLayer.push({ event: 'register.createPickupPerson' }),
  redirect: '/pickup_people'
})(UI)
